<template>
  <DBox
    :id="'cmp-settings-externalusers-external_access_list'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('new_permission')}`"
    @add_click="onAddClick"
  >
    <div class="settings-externalusers-external_access_list">
      <NTable
        class="h1 dbox1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr :title="item.royalty_account_name">
            <td @click="onUserItemClick(item)" v-bind="tdcon('royalty_account_name')">
              <span :title="item['royalty_account_name']">
                {{ item["royalty_account_name"] }}
              </span>
            </td>

            <td v-bind="tdcon('options')">
              <img
                @click.stop="(e) => onExternalUserPermissionDelete(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1 ut-center"
                :alt="$t('delete_user_permission')"
                :title="$t('delete_user_permission')"
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>
    
    <script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { mapGetters } from "vuex";
export default {
  components: {
    NTable,
    DBox,
  },
  props: {
    selectedUserDetails: {
      type: Object,
      default: () => [],
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 32,
        fullHeight: true,
        footer: false,
        showHeader:false
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("royalty_account_name"),
        createTableHeader("options", { text: false, mw: 50 }),
      ];
    },
    list: function () {
      return this.selectedUserDetails?.royalty_accounts || [];
    },
    external_user_id: function () {
      return this.$route.params.external_user_id;
    },
  },
  methods: {
    onAddClick: function () {
      this.$emit("add_click", "add_permission_external_user_form");
    },
    onExternalUserPermissionDelete: function (item) {
      this.$emit("externalUserPermissionDelete", item);
    },
    // MARK: Methods
  },
};
</script>
  <style lang="scss">
.cmp-settings-externalusers-external_access_list {
  .settings-externalusers-external_access_list {
    overflow: hidden;
    .dt-ntable {
      --ntable-height: none !important;
    //   thead{
    //     display: none;
    //   }
      td:first-child:hover {
        text-decoration: none;
        font-weight: 400;
      }
      td:first-child {
        font-weight: 400;
      }
    }
   
  }
}
</style>
    